<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header"><i class="fa fa-edit"></i><strong> Настройки ИНН</strong> </div>
                    <p>Укажите поле для ввода ИНН</p>
                    <b-row class="mb-3">
                        <b-col md="2">ИНН:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.innField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('ИНН')"><b-link class="dashed" @click="createCompanyField('ИНН')">Создать поле</b-link></b-col>
                    </b-row>

                    <p>Укажите автозаполняемые поля</p>

                    <b-row class="mb-3">
                        <b-col md="2">Юр. Лицо:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.urNameField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('Юр. лицо')"><b-link class="dashed" @click="createCompanyField('Юр. лицо')">Создать поле</b-link></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="2">Юр. Адрес:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.urAdresField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('Юр. адрес')"><b-link class="dashed" @click="createCompanyField('Юр. адрес')">Создать поле</b-link></b-col>
                    </b-row>
                    
                    <b-row class="mb-3">
                        <b-col md="2">ОГРН:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.ogrnField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('ОГРН')"><b-link class="dashed" @click="createCompanyField('ОГРН')">Создать поле</b-link></b-col>
                    </b-row>
                    
                    <b-row class="mb-3">
                        <b-col md="2">КПП:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.kppField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('КПП')"><b-link class="dashed" @click="createCompanyField('КПП')">Создать поле</b-link></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="2">Руководитель:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.managerField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('Руководитель')"><b-link class="dashed" @click="createCompanyField('Руководитель')">Создать поле</b-link></b-col>
                    </b-row>
                </b-card>

                <b-card>
                    <div slot="header"><i class="fa fa-edit"></i><strong> Настройки БИК</strong> </div>
                    <p>Укажите поле для БИК</p>
                    <b-row class="mb-3">
                        <b-col md="2">БИК:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.bikField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('БИК')"><b-link class="dashed" @click="createCompanyField('БИК')">Создать поле</b-link></b-col>
                    </b-row>

                    <p>Укажите автозаполняемые поля</p>

                    <b-row class="mb-3">
                        <b-col md="2">Название банка:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.bankNameField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('Название банка')"><b-link class="dashed" @click="createCompanyField('Название банка')">Создать поле</b-link></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="2">Кор. счет:</b-col>
                        <b-col md="6"><b-form-select  v-model="settings.bankKorField" :options="amoCompanyFields"></b-form-select></b-col>
                        <b-col md="4" v-show="!checkField('Кор. счет')"><b-link class="dashed" @click="createCompanyField('Кор. счет')">Создать поле</b-link></b-col>
                    </b-row>

                    <div slot="footer">
                        <b-button type="submit" size="sm" variant="primary" v-on:click="saveSettings()" :disabled="!widget.isActive"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>
                        Если вы часто выставляете клиентам документы по юридическим реквизитам, то этот виджет поможет с их заполнением в карточку компании. Вводите ИНН, а остальные данные виджет заполнит из справочника. Также с банковскими реквизитами по БИК
                    </p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';

    export default {
        mixins: [
            widgetEvents,
        ],
        components: {  }, 
        name: 'AutoINN',
        data () {
            return {
                widget:  { isActive : false },
                widgetId: '5cc01a6400112945ba79e74f',
                settings : {
                    urAdresField : '',
                    urNameField : '',
                    innField : '',
                    kppField : '',
                    managerField : '',
                    bikField : '',
                    bankNameField : '',
                    bankKorField : '',
                    ogrnField : '',
                },
                amoCompanyFields : [ ],
                disabledField: true,
                onLoad : false,
            }
        },
        created: function () {
            this.getWidget(() => this.getCompanyFields());
        },
        methods: {
            // Создаем поле компании
            async createCompanyField(fieldName){
                this.disabledField = true;
                await WidgetsService.createCompanyField(fieldName).then(response => {
                    this.disabledField = false;
                    this.getCompanyFields ();
                }).catch(err => { return console.log(err); });
            },

            // Получаем все поля компании
            async getCompanyFields () {
                this.disabledField = true;
                await WidgetsService.getCompanyFields().then(response => {                    
                    this.amoCompanyFields = response.data.result;
                    this.setFieldsValues();
                    this.disabledField = false;
                }).catch(err => { return console.log(err); });
            },

            // Заносим в списке поля
            setFieldsValues() {
                var vueApp = this;

                this.amoCompanyFields.forEach(function(field) {
                    if(!vueApp.settings.innField && field.text == 'ИНН')                 vueApp.settings.innField        = field.value;
                    if(!vueApp.settings.urNameField && field.text == 'Юр. лицо')         vueApp.settings.urNameField     = field.value;
                    if(!vueApp.settings.urAdresField && field.text == 'Юр. адрес')       vueApp.settings.urAdresField    = field.value;
                    if(!vueApp.settings.ogrnField && field.text == 'ОГРН')               vueApp.settings.ogrnField       = field.value;
                    if(!vueApp.settings.kppField && field.text == 'КПП')                 vueApp.settings.kppField        = field.value;
                    if(!vueApp.settings.managerField && field.text == 'Руководитель')    vueApp.settings.managerField    = field.value;
                    if(!vueApp.settings.bikField && field.text == 'БИК')                 vueApp.settings.bikField        = field.value;
                    if(!vueApp.settings.bankNameField && field.text == 'Название банка') vueApp.settings.bankNameField   = field.value;
                    if(!vueApp.settings.bankKorField && field.text == 'Кор. счет')       vueApp.settings.bankKorField    = field.value;
                });
            },

            // Проверяем есть ли в списке необходимое поле
            checkField(fieldName) {
                var found = this.amoCompanyFields.find(function(field) {
                    return field.text == fieldName;
                });
                return found;
            },
            // Инициализируем настройки
            setSettings(settings) {
                this.urAdresField        = settings.urAdresField;
                this.urNameField         = settings.urNameField;
                this.innField            = settings.innField;
                this.kppField            = settings.kppField;
                this.managerField        = settings.managerField;
                this.bikField            = settings.bikField;
                this.bankNameField       = settings.bankNameField;
                this.bankKorField        = settings.bankKorField;
                this.ogrnField           = settings.ogrnField;
            },
        }
    }
    
</script>